function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { SVGIcon } from '@homeaway/react-svg';
import { CHEVRON_DOWN__12 } from '@homeaway/svg-defs';
import "./FormSelect.css";

var FormSelect =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(FormSelect, _Component);

  function FormSelect() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleChange = function (event) {
      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    return _this;
  }

  var _proto = FormSelect.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        id = _this$props.id,
        name = _this$props.name,
        items = _this$props.items,
        label = _this$props.label,
        value = _this$props.value,
        errorMsg = _this$props.errorMsg,
        floatingLabel = _this$props.floatingLabel,
        itemValueKey = _this$props.itemValueKey,
        itemLabelKey = _this$props.itemLabelKey,
        children = _this$props.children,
        className = _this$props.className,
        rest = _objectWithoutProperties(_this$props, ["id", "name", "items", "label", "value", "errorMsg", "floatingLabel", "itemValueKey", "itemLabelKey", "children", "className"]);

    var formSelectClasses = classNames('form-group', className, {
      'not-empty': !!value || !!(items && items[0] && items[0][itemLabelKey]) || !!children
    }, {
      'has-error': !!errorMsg
    }, {
      'floating-label': !!floatingLabel
    });
    var options = null;

    if (items) {
      options = items.map(function (item, index) {
        return React.createElement("option", {
          disabled: item.disabled,
          hidden: item.hidden,
          key: index,
          value: item[itemValueKey]
        }, item[itemLabelKey]);
      });
    }

    return React.createElement("div", {
      className: formSelectClasses
    }, React.createElement("label", {
      htmlFor: id
    }, label), React.createElement("div", {
      className: "FormSelect__wrapper"
    }, React.createElement("select", _extends({
      id: id,
      "aria-label": label,
      name: name,
      className: "form-control FormSelect__select",
      value: value ? value : '',
      onChange: this.handleChange
    }, rest), children, options), React.createElement(SVGIcon, {
      markup: CHEVRON_DOWN__12,
      className: "FormSelect__chevron",
      "aria-hidden": true
    })), errorMsg && React.createElement("span", {
      className: "help-block",
      dangerouslySetInnerHTML: {
        __html: errorMsg
      }
    }));
  };

  return FormSelect;
}(Component);

FormSelect.propTypes = {
  /** id for label, required for a11y.  A generated one is provided if not specified, which may not play nicely with SSR.  It is best to provide a unique id yourself. */
  id: PropTypes.string,

  /** Form label for the select */
  label: PropTypes.string.isRequired,

  /** Array of items to feed to FormSelect as child <option> tags */
  items: PropTypes.array,
  // eslint-disable-line react/forbid-prop-types

  /** Name attribrute for the select tag */
  name: PropTypes.string.isRequired,

  /** Flag to use default Baseline floating label tag. Setting to false will have the label display as a block element above the form select */
  floatingLabel: PropTypes.bool,

  /** Key to use for option label in items array */
  itemLabelKey: PropTypes.string,

  /** Key to use for option value in items array */
  itemValueKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** The current selected value, if there is one */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Error message to display, if needed. Will also turn on .has-error className */
  errorMsg: PropTypes.string,

  /** Event handler to wire in when the FormSelect changes */
  onChange: PropTypes.func
};
FormSelect.defaultProps = {
  floatingLabel: true,
  itemLabelKey: 'label',
  itemValueKey: 'value',
  id: "select-" + Math.random().toString(36).substr(2, 9)
};
export default FormSelect;
//# sourceMappingURL=FormSelect.js.map